module.exports = __webpack_public_path__ + "img/logo_inviv_full_white.43e9438f.png";